import React from 'react';
import ModuleDatabaseFeature from '~/components/ModuleDatabaseFeature';

const ModuleDatabaseView = (props: {
  changeBreadcrumbPageTitle: (moduleName: string) => void;
}) => <ModuleDatabaseFeature {...props} />;

export default ModuleDatabaseView;
